import { connect } from 'react-redux';
import GridItem from '../material-ui/Grid/GridItem';
import DashboardCard from './DashboardCard';
import GridContainer from '../material-ui/Grid/GridContainer';
import React from 'react';
import Icon from '@material-ui/core/Icon';
import { Box } from '@material-ui/core';


class DashboardMediumTypesStats extends React.Component {
  componentDidMount() {
  }

  render() {
    const { messages, mediumTypes, loading, classes } = this.props;


    return (
      <GridContainer>
        {loading && messages.length === 0 && (
          <span>Loading...</span>
        )}

        {mediumTypes.filter(mediumType => mediumType.useInStats)
          .map((mediumType) => {
            return (
              <GridItem xs={12} sm={6} md={4} key={mediumType.id}>
                <DashboardCard color={mediumType.color} icon={mediumType.icon} name={mediumType.name}
                               value={messages.filter(x => x.medium && x.medium.id === mediumType.id).reduce((sum, message) => sum + (message.receivers || 0), 0)}
                               footer={<Box><Icon>calendar_today</Icon> In den letzen 14 Tagen</Box>} classes={classes}>
                </DashboardCard>
              </GridItem>
            );
          })}
      </GridContainer>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardMediumTypesStats);
